import { BasicCalls } from '..'

class Recommender extends BasicCalls {
    constructor() {
        super()
        this.apiBase = 'recommend'
        this.apiRoot = 'frontend-api'
        this.apiVersion = ''
    }

    fetch({ id, mealsCount = 10, dessertCount = 2, drinkCount = 2, meals = [], price }) {
        if (!id || !price || !meals?.length) throw new Error('Missing parameter!')
        return super.store(undefined, {
            restaurantId: id, // kötelező
            recommendedMealsCount: mealsCount, // kötelező, ennyi kaját fog ajánlani
            maxDessertCount: dessertCount, // kötelező, a kért darabszámú kaján belül ennyi dessert lesz, ha a kosrában nincs desszert
            maxDrinkCount: drinkCount, // kötelező, ua. mint dessert csak italra
            mealIdsInCart: meals, // kötelező, lehet üres tömb, kosár tartalma, ezeket a kajákat nem fogja ajánlani mégegyszer
            totalPrice: price, // kötelező, kosár összege
        })
    }
}
export { Recommender }
